import $ from 'jquery';
const ELEMENT_SELECTOR = '.js__tabs-dropdown';
export class TabsDropdown {
    static init($root = $('body')) {
        const $elements = $root.find(ELEMENT_SELECTOR);
        if (!$elements.length) {
            return;
        }
        $elements.each(() => {
            this.initTabChangeHandle($elements);
        });
    }
    static initTabChangeHandle($elements) {
        const $dropdownItem = $elements.find('.item');
        const $tabs = $elements.closest('.ui.menu').children();
        $dropdownItem.on('click', e => {
            $(e.currentTarget).closest('.ui.menu').find('.item.active').removeClass('active');
        });
        $tabs.on('click', e => {
            const $tab = $(e.currentTarget);
            const { tab } = $tab.data();
            if (tab) {
                $dropdownItem.siblings().find('.item.active').addBack().removeClass('active');
            }
        });
    }
}
